import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getInboxNotifications } from "../api/notification.api";
import { NotificationMessage } from "../types/notification.types";
import { useProfile } from "../../auth/hooks/useProfile";

const NotificationDropdownList = ({ close }: any) => {
  const [messages, setMessages] = useState<NotificationMessage[]>([]);
  const { user } = useProfile();

  useEffect(() => {
    if (!user?.id) return;

    const fetchInbox = async () => {
      const response = await getInboxNotifications({
        page: 1,
        limit: 3,
      });

      if (response.success) {
        setMessages(response.data.rows);
      }
    };

    fetchInbox();
  }, [user]);

  return (
    <div className="w-[300px] sm:w-[340px] max-w-[90vw]">

      <div className="px-4 sm:px-6 pt-4 pb-2 text-sm font-medium text-[#26295e]">
        {messages.length === 0 ? "You're all caught up!" : "New Messages"}
      </div>

      <div className="max-h-[260px] overflow-y-auto">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className="px-4 sm:px-5 py-3 border-t hover:bg-gray-50 transition cursor-pointer"
          >
            <div className="flex items-center justify-between">
              <div className="font-medium text-[14px] text-[#26295e]">
                {msg.sender.first_name} {msg.sender.last_name}
              </div>

              {!msg.read && (
                <span className="w-2 h-2 bg-indigo-500 rounded-full"></span>
              )}
            </div>
            <div className="text-sm text-gray-500 truncate">
              {msg.subject}
            </div>
          </div>
        ))}
      </div>

      <div className="border-t mt-2" />

      <Link
        to="/notifications"
        onClick={close}
        className="block px-4 sm:px-5 py-3 text-center text-[14px] sm:text-[15px] underline hover:no-underline"
      >
        View inbox
      </Link>
    </div>
  );
};

export default NotificationDropdownList;